import type { ServicingFeatureConfig } from '../../../types/features/ServicingFeatureConfig';

export const servicing: ServicingFeatureConfig = {
    specificRedirection: true,
};
